import { render, staticRenderFns } from "./new-api-key.vue?vue&type=template&id=5ce00707"
import script from "./new-api-key.vue?vue&type=script&lang=js"
export * from "./new-api-key.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports